import { useSelector } from "react-redux"
import styled from "styled-components"
import UpdateFAQ from "./UpdateFAQ"
import UpdateBlogNewFAQSide from "./UpdateBlogNewFAQSide"

const Container = styled.div`
    height: 100%;
    width: 100%;
    .border{
        border-top: 3px solid ${({theme}) => theme.mainBorderColor};
    }
    
`


const UpdateFAQContentController = ({data}) => {
    const {selectedBlog} = useSelector((state) => state.admin3)
    
  return (

    <Container>

        {selectedBlog?.faqBlogs?.length > 0 && 
            selectedBlog?.faqBlogs?.map((item) => {
                return (
                    <UpdateFAQ data={item} />
                )
            })
        }
        
        {
            selectedBlog?.faqBlogs?.length > 0 && 
            <div className="border" />
        }

        <UpdateBlogNewFAQSide />
        
    </Container>
  )
}

export default UpdateFAQContentController